export default "__VITE_ASSET__CSq0NC9v__"